import {Component, OnInit, Input, Inject} from "@angular/core";
import {MatBottomSheet} from "@angular/material/bottom-sheet";
import {MAT_BOTTOM_SHEET_DATA} from "@angular/material";
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from "@angular/material/dialog";

@Component({
  selector: "app-confirmation-sheet",
  templateUrl: "./confirmation-sheet.component.html",
  styleUrls: ["./confirmation-sheet.component.css"]
})
export class ConfirmationSheetComponent implements OnInit {

  get title(): string {
    return this._title;
  }


  @Input()
  set title(value: string) {
    this._title = value;
  }

  private _message: string = "";

  @Input()
  public set message(message: string) {
    this._message = (message && message.trim()) || "";
  }

  public get message(): string {
    return this._message;
  }

  private _title: string = "";

  constructor(public dialogRef: MatDialogRef<ConfirmationSheetComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {
    if (data) {
      this.title = data.title || "??";
      this.message = data.message || "??"
    }
  }

  ngOnInit() {
  }

  noClick() {
    this.dialogRef.close(ConfirmationResult.No)
  }

  yesClick() {
    this.dialogRef.close(ConfirmationResult.Yes)
  }

}

export enum ConfirmationResult {
  Yes,
  No
}
